<template>
  <ValidationProvider
    v-slot="{ errors, valid, validated }"
    :name="name"
    :rules="getValidation"
    slim
  >
    <basic-form-group
      :id="$attrs.id"
      :label-is-up="labelIsUp"
      :label="$attrs.label"
      :hint="$attrs.hint"
      :required="$attrs.required"
      :horizontal="$attrs.horizontal"
    >
      <typeahead
        :id="id"
        v-model="model"
        :is-invalid="!valid && validated"
        :name="name"
        v-bind="$attrs"
        :strict="$attrs.strict"
        v-on="typeaheadListeners"
      >
        <template
          v-slot="slotData"
        >
          <slot
            v-bind="slotData"
          />
        </template>
      </typeahead>
    </basic-form-group>
  </ValidationProvider>
</template>

<script>
import Typeahead from '../Typeahead/Typeahead.vue'
import basicComponentMixin from './basic-component-mixin.js'

export default {
  name: 'BasicTypeahead',
  components: {
    Typeahead
  },
  mixins: [basicComponentMixin],
  computed: {
    typeaheadListeners () {
      return {
        hit: (event) => {
          this.$emit('input', event)
        },
        ...this.listeners
      }
    }
  }
}
</script>
